import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { NOTHSAndMoreLogo } from "./NOTHSAndMoreLogo";
import * as styles from "./MembershipBanner.styles";
import { SolidButtonLink } from "../../elements/Button/SolidButton/SolidButtonLink";
export var MembershipBanner = function MembershipBanner(_ref) {
  var buttonHref = _ref.buttonHref,
    buttonText = _ref.buttonText,
    copy = _ref.copy,
    heading = _ref.heading,
    _ref$onButtonClick = _ref.onButtonClick,
    onButtonClick = _ref$onButtonClick === void 0 ? function () {} : _ref$onButtonClick,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: observedElementRef,
    $_css: styles.root
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.logo
  }, /*#__PURE__*/React.createElement(NOTHSAndMoreLogo, null)), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: styles.content
  }, /*#__PURE__*/React.createElement(_StyledH, {
    $_css4: styles.heading
  }, heading), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css5: styles.body
  }, copy && /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: copy
    }
  }), /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css6: styles.button
  }, buttonText && buttonHref && /*#__PURE__*/React.createElement(SolidButtonLink, {
    fullWidth: true,
    href: buttonHref,
    onClick: onButtonClick
  }, buttonText)))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv3 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledH = _styled4("h3")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledDiv4 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv5 = /*#__PURE__*/_styled6("div").withConfig({
  displayName: "MembershipBanner___StyledDiv5",
  componentId: "sc-ldgmkf-0"
})(["", ""], function (p) {
  return p.$_css6;
});